<template>
	<HereMaps
		name="map-iot"
		latitude="4.686699"
		longitude="-74.0837187"
		zoom="13"
		:theme="mapTheme"
		streetview="true"
	></HereMaps>
</template>

<script>
import HereMaps from "@/components/Maps/Maps.vue";

export default {
	name: "mapa",
	data() {
		return {
			msj: "helo",
		};
	},
	components: {
		HereMaps,
	},
	computed: {
		mapTheme() {
			return this.$store.state.moduleMap.mapStyle;
		},
	},
};
</script>
